/* CYBEART SECTION SYSTEM (2026-09-27) — hover for .cy-sys--hover tiles: a soft spotlight (.cys-spot); since 2026-10-16 pm the
   running light and the pointer tracking are the design system's (the block prints cy-frame + data-light="card", cybeart.js frames the tile)
   centred on the pointer, and the running light (.cys-ring) — a red arc on the card border pointed at
   the pointer, the product-card effect rebuilt for section cards. rAF-throttled.
   Mouse devices with motion allowed only; everything else is CSS. */
(function () {
  'use strict';
  if (window.CySectionSystem) return;
  window.CySectionSystem = true;
  var mq = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  if (!mq || !mq.matches) return;

  function arm(scope) {
    (scope || document).querySelectorAll('.cy-sys--hover.cy-sys--tiles .hdt-tcwi-inner')   /* 2026-10-16 design system v3.2: section cards (.cys-card) are framed and lit by cybeart.js; only the text-column tiles keep this spot + ring */.forEach(function (tile) {
      /* 2026-10-11 (owner: 'apply same hover animation style for Resources cards'): cards that print their own spot + ring in
         Liquid (CY Support downloads) were skipped entirely, so their arc never followed the cursor; now every card is wired once
         and the spot / ring are only added when missing */
      if (tile.dataset.cysHover) return; tile.dataset.cysHover = '1';
      if (!tile.querySelector(':scope > .cys-spot')) {
        var spot = document.createElement('span');
        spot.className = 'cys-spot';
        spot.setAttribute('aria-hidden', 'true');
        tile.prepend(spot);
      }
      /* 2026-10-16 pm: the ring and the pointer tracking moved to the one edge renderer (cybeart.js writes --mx / --my / --cy-ang on the framed tile); the spot above stays */
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
  else arm();
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
})();

/* ---- sticky menu (CY Sticky menu) ---- */
/* Keeps a [data-cys-subnav][data-sticky] section directly under the site header. The Kalles header is
   "sticky on scroll up" (it slides away on scroll down), so the menu follows the header's REAL bottom
   edge each frame the page scrolls: --cys-subnav-top on <html> = max(0, header bottom). Runs for every
   visitor (not only mouse users), independent of the hover code above. */
(function () {
  'use strict';
  if (window.CySubnav) return; window.CySubnav = true;
  /* 2026-10-07 (mobile motion audit): no setInterval (it ran 2.5 times a second forever), the header element and its
     position are looked up once (again on resize / section reload), not every frame. After each scroll the menu follows
     the header for 700 ms (the header's own slide), then nothing runs until the next scroll. */
  var h = null, hPinned = false, navs = [], last = -1, watched = null;
  /* the header hides / returns by a class switch + its own slide, sometimes after the scroll has stopped: a change of its
     classes or the end of its slide also re-runs the follow (event-driven, nothing polls) */
  var mo = 'MutationObserver' in window ? new MutationObserver(function () { ask(); }) : null;
  /* 2026-10-23 (speed, MEDIA-SPEED-PLAN phase 1): a custom property written on <html> re-styles the WHOLE page (about 6,000 elements carrying
     ~490 custom properties), and this wrote one every frame the header slid: most of the phones' frozen time on the compare pages and the FAQ.
     Where :has() works the offset now comes from CSS (cy-section-system.css: the header's own state classes, as the sticky menu itself since
     2026-10-21) and the script only keeps the menu's is-stuck class; the script value stays for browsers without :has(). The observer watches
     the header element itself, not its whole subtree (the mega menus' own class changes re-ran the follow loop). */
  var HAS = !!(window.CSS && CSS.supports && CSS.supports('selector(:has(*))'));
  function measure() {
    navs = [].slice.call(document.querySelectorAll('[data-cys-subnav][data-sticky]'));
    h = document.querySelector('.hdt-section-header') || document.querySelector('.shopify-section-header-sticky, [id*="__header"], header-section, .hdt-header, header');   /* the Kalles header section first (2026-10-21) */
    var st = h ? getComputedStyle(h) : null; hPinned = !!st && (st.position === 'sticky' || st.position === 'fixed');
    if (h && h !== watched && navs.length) {
      watched = h;
      if (mo) { mo.disconnect(); mo.observe(h, { attributes: true, attributeFilter: ['class', 'style'] }); }
      h.addEventListener('transitionend', ask); h.addEventListener('animationend', ask);
    }
  }
  function sync() {
    if (!navs.length) return;
    var top = 0;
    if (h) { var b = h.getBoundingClientRect(); if ((hPinned || b.top < 0 || b.bottom > 0) && b.bottom > 0) top = Math.round(b.bottom); }
    if (top !== last) { last = top; if (!HAS) document.documentElement.style.setProperty('--cys-subnav-top', top + 'px'); }
    navs.forEach(function (n) { var r = n.getBoundingClientRect(); n.classList.toggle('is-stuck', r.top <= top + 1 && window.scrollY > 0); });
  }
  var until = 0, looping = false;
  function loop() { sync(); if (performance.now() < until) requestAnimationFrame(loop); else looping = false; }
  function ask() { until = performance.now() + 700; if (!looping) { looping = true; requestAnimationFrame(loop); } }
  function start() { measure(); ask(); }
  window.addEventListener('scroll', ask, { passive: true });
  /* 2026-10-21: some phone browsers (Samsung Internet) end a fling without a late scroll event: settle once more when scrolling ends, and on return to the tab */
  window.addEventListener('scrollend', ask, { passive: true }); document.addEventListener('visibilitychange', function () { if (!document.hidden) ask(); });
  if (window.visualViewport) visualViewport.addEventListener('resize', ask);
  window.addEventListener('resize', start);
  window.addEventListener('load', ask);
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ---- button label roll: since 2026-10-16 cybeart.js (design system v3.2) wraps the labels (.cys-roll); the copy that lived here is in git ---- */

/* ---- sticky menu: current page in view ---- */
/* On narrow screens the menu row scrolls sideways; bring the current page's link into view on load. */
(function () {
  'use strict';
  if (window.CySys2) return; window.CySys2 = true;   /* one tag per section: run once */
  function centre() {
    document.querySelectorAll('[data-cys-subnav] .cys-subnav__tabs').forEach(function (tabs) {
      var a = tabs.querySelector('.is-active'), row = tabs.closest('.cys-subnav__scroll') || tabs;
      if (!a || row.scrollWidth <= row.clientWidth) return;
      if (a === tabs.querySelector('a')) { row.scrollLeft = 0; return; }   /* first link: keep the label in front */
      var ab = a.getBoundingClientRect(), rb = row.getBoundingClientRect();
      row.scrollLeft += ab.left - rb.left - (row.clientWidth - ab.width) / 2;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', centre); else centre();
})();

/* ---- policy document contents list ---- */
/* CY Page content, layout "Policy document": builds the "On this page" list from the text's H2 headings
   (needs 3+), gives each heading an id so the list and #links work, marks the section being read, and on
   phones keeps the list collapsed and closes it after a pick. */
(function () {
  'use strict';
  if (window.CySys3) return; window.CySys3 = true;   /* one tag per section: run once */
  var slug = function (s) { return String(s).toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60); };
  function build(doc) {
    if (doc.dataset.cysDone) return; doc.dataset.cysDone = '1';
    var toc = doc.querySelector('[data-cys-toc]'), list = toc && toc.querySelector('.cys-doc__list'), box = toc && toc.querySelector('details');
    var hs = [].slice.call(doc.querySelectorAll('.cys-prose h2')).filter(function (h) { return h.textContent.trim(); });
    if (!toc || hs.length < 3) { doc.classList.add('cys-doc--solo'); return; }
    var used = {}, links = [];
    hs.forEach(function (h) {
      var id = h.id || slug(h.textContent) || 'section'; var base = id, n = 2; while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) id = base + '-' + n++;
      used[id] = 1; h.id = id;
      var li = document.createElement('li'), a = document.createElement('a'); a.href = '#' + id; a.textContent = h.textContent.trim().replace(/\s+/g, ' ');
      a.addEventListener('click', function (e) {
        /* land the heading 24px under the sticky bars. The site header hides on scroll DOWN and returns on
           scroll UP, so the bars' final position depends on the direction of the jump. */
        e.preventDefault();
        if (window.matchMedia('(max-width: 1023px)').matches && box) box.open = false;
        var bar = document.querySelector('[data-cys-subnav]'), barH = bar ? bar.getBoundingClientRect().height : 0;
        var hdr = document.querySelector('.shopify-section-header-sticky, [id*="__header"], .hdt-header, header');
        var hdrH = hdr ? hdr.getBoundingClientRect().height : 0;
        var y = h.getBoundingClientRect().top + window.scrollY;
        var goingUp = y < window.scrollY;
        var target = y - barH - 24 - (goingUp ? hdrH : 0);
        window.scrollTo({ top: Math.max(0, target), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        history.replaceState(null, '', '#' + h.id);
        lock = Date.now() + 900; mark(links.indexOf(a));
      });
      li.appendChild(a); list.appendChild(li); links.push(a);
    });
    toc.hidden = false;
    if (box && window.matchMedia('(max-width: 1023px)').matches) box.open = false;
    if (box) box.querySelector('summary').addEventListener('click', function (e) { if (!window.matchMedia('(max-width: 1023px)').matches) e.preventDefault(); });
    var current = null, lock = 0;
    function mark(i) {
      if (i === current) return; current = i;
      links.forEach(function (a, k) { a.classList.toggle('is-current', k === i); if (k === i) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      var a = links[i]; if (a && list.scrollHeight > list.clientHeight) { var t = a.offsetTop - list.clientHeight / 2; list.scrollTop = t; }
    }
    function spy() {
      if (Date.now() < lock) return; /* a click just set the current item; let the smooth scroll finish */
      var bar = document.querySelector('[data-cys-subnav]');
      var line = (bar ? bar.getBoundingClientRect().bottom : 0) + 60, i = 0;
      hs.forEach(function (h, k) { if (h.getBoundingClientRect().top <= line) i = k; });
      mark(i);
    }
    var raf = 0; window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; spy(); }); }, { passive: true });
    spy();
  }
  function all() { document.querySelectorAll('[data-cys-doc]').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

/* ---- policy tables ---- */
/* CY Page content (.cy-sys--prose): tables typed in the page editor have no header markup. Without touching the
   text, each table gets real headings and a layout class (styles in cy-section-system.css, "policy tables"):
   - 3+ columns: the first row becomes the header (th scope=col) and each row's first cell its heading
     (th scope=row); every value carries its column name (data-label) for the phone card layout; "Not
     Applicable" / "N/A" values are muted;
   - 2 columns: the first cell of each row becomes its heading (label | details).
   Explicit ARIA roles keep the table readable to screen readers when phones restyle it as cards.
   The theme wraps tables in a scroll box by replacing their HTML, so the work is done in the markup itself. */
(function () {
  'use strict';
  if (window.CySys4) return; window.CySys4 = true;   /* one tag per section: run once */
  function txt(el) { return el.textContent.replace(/\s+/g, ' ').trim(); }
  function firstLine(el) { var p = el.querySelector('p, strong, b'); return p && txt(p) ? txt(p) : txt(el); }
  function toTh(cell, scope) {
    if (cell.tagName === 'TH') { cell.setAttribute('scope', scope); return cell; }
    var th = document.createElement('th'); th.setAttribute('scope', scope);
    for (var i = 0; i < cell.attributes.length; i++) th.setAttribute(cell.attributes[i].name, cell.attributes[i].value);
    while (cell.firstChild) th.appendChild(cell.firstChild);
    cell.parentNode.replaceChild(th, cell); return th;
  }
  function clean(cell) { /* empty paragraphs (&nbsp;) from the editor make tall gaps */
    [].forEach.call(cell.querySelectorAll('p'), function (p) { if (!txt(p) && !p.querySelector('img')) p.remove(); });
  }
  function enhance(t) {
    if (t.dataset.cysTbl || t.querySelector('td[colspan], td[rowspan], th[colspan], th[rowspan]')) return;
    var rows = [].slice.call(t.rows); if (rows.length < 2) return;
    var cols = rows[0].cells.length;
    if (cols < 2 || rows.some(function (r) { return r.cells.length !== cols; })) return;
    t.dataset.cysTbl = '1';
    rows.forEach(function (r) { [].forEach.call(r.cells, clean); });
    t.setAttribute('role', 'table');
    if (cols >= 3) {
      t.classList.add('cys-tbl', 'cys-tbl--grid');
      var head = t.tHead || t.createTHead();
      if (!head.rows.length) head.appendChild(rows[0]);
      var labels = [].map.call(head.rows[0].cells, function (c) { return firstLine(c); });
      [].slice.call(head.rows[0].cells).forEach(function (c) { toTh(c, 'col').setAttribute('role', 'columnheader'); });
      head.rows[0].setAttribute('role', 'row');
      [].forEach.call(t.tBodies, function (b) {
        [].slice.call(b.rows).forEach(function (r) {
          r.setAttribute('role', 'row');
          [].slice.call(r.cells).forEach(function (c, i) {
            if (i === 0) { toTh(c, 'row').setAttribute('role', 'rowheader'); return; }
            c.setAttribute('role', 'cell'); c.setAttribute('data-label', labels[i] || '');
            if (/^(not applicable|n\/a|—|-)$/i.test(txt(c))) c.classList.add('is-na');
          });
        });
      });
    } else {
      t.classList.add('cys-tbl', 'cys-tbl--kv');
      [].forEach.call(t.tBodies, function (b) {
        [].slice.call(b.rows).forEach(function (r) {
          r.setAttribute('role', 'row');
          toTh(r.cells[0], 'row').setAttribute('role', 'rowheader');
          r.cells[1].setAttribute('role', 'cell');
        });
      });
    }
  }
  function all() {
    /* the theme re-writes table HTML when it wraps them; find tables fresh each time */
    document.querySelectorAll('.cy-sys--prose .cys-prose table').forEach(enhance);
  }
  function run() { all(); setTimeout(all, 400); setTimeout(all, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

/* ---- eyebrow logo-E: assemble once when it comes into view ("Ignition", 2026-10-06) ---- */
/* Arms every section eyebrow (data-e="armed": the bars wait at zero width) and flips it to "in" the first time it is 60%
   visible, which runs the CSS assemble and starts the glint. No IntersectionObserver, or reduced motion: nothing is armed,
   so the E simply stands complete. */
(function () {
  'use strict';
  if (window.CySysE) return; window.CySysE = true;
  if (!('IntersectionObserver' in window) || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
  /* 2026-10-07: the mark stays observed after it has assembled, so its 6 s glint can pause while it is off screen
     (data-e-off, CSS sets animation-play-state: paused) — no visual change on screen, no repaints off screen */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (en) {
      var t = en.target;
      if (!en.isIntersecting) { t.setAttribute('data-e-off', ''); return; }
      t.removeAttribute('data-e-off');
      if (en.intersectionRatio >= 0.6 && t.getAttribute('data-e') === 'armed') t.setAttribute('data-e', 'in');
    });
  }, { threshold: [0, 0.6] });
  /* section eyebrows + (owner 2026-10-07) the sticky-menu label, the mega panel headings and the footer column titles */
  var MEGA = '.hdt-main-header .cy-mega:not(.cy-mega--support) .cy-mega__heading';
  var MARKS = ['.cy-sys .cys-eyebrow', '.cy-sys--subnav .cys-subnav__label', MEGA, '.cy-footer .cy-footer__coltitle'];
  /* 2026-10-20: a section that prints data-e="armed" itself (cy-features, cy-backed, cy-licensed-set) was skipped by the old
     :not([data-e]) and its E stayed at zero width for good; now every mark that is not "in" yet is observed, once */
  function arm(scope) {
    (scope || document).querySelectorAll(MARKS.map(function (s) { return s + ':not([data-e="in"])'; }).join(',')).forEach(function (e) {
      if (e.cyEObserved) return; e.cyEObserved = true;
      if (!e.hasAttribute('data-e')) e.setAttribute('data-e', 'armed');
      io.observe(e);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); }); else arm();
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  /* a mega panel that opens replays its headings' bars, so the bullet is seen assembling every time */
  document.addEventListener('toggle', function (e) {
    var d = e.target; if (!d.open || !d.closest || !d.closest('.hdt-main-header')) return;
    d.querySelectorAll(MEGA).forEach(function (h) { h.setAttribute('data-e', 'armed'); void h.offsetWidth; h.setAttribute('data-e', 'in'); h.removeAttribute('data-e-off'); });
  }, true);
})();

/* ONE OPEN (2026-10-07, owner: "FAQ - open one at one time"): in a [data-cy-one-open] list (CY Accordion "One question
   open at a time"), opening a question closes the open one through the accordion's own toggle(), so its animation and
   aria state stay right. */
(function () {
  if (window.CySysOneOpen) return; window.CySysOneOpen = true;
  document.addEventListener('toggle', function (e) {
    var d = e.target; if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    var box = d.closest && d.closest('[data-cy-one-open]'); if (!box) return;
    box.querySelectorAll('hdt-accordion').forEach(function (a) {
      if (a.contains(d)) return;
      var od = a.querySelector('details'); if (!od || !od.open) return;
      if (typeof a.toggle === 'function') a.toggle(false); else od.removeAttribute('open');
    });
  }, true);
})();

/* ---- SECTION CARDS (global, owner 2026-10-18): the tilt (eased every frame, the angle from --cys-card-tilt, less on wide cards) on mouse
   devices; on touch screens the card in view of its row (or the viewport) and a tapped card get .is-touch when --cys-card-touch is 1.
   Cards = [data-cy-card-fx] :is([data-cy-fx], .hdt-tcwi-inner). Re-armed on shopify:section:load. ---- */
(function () {
  'use strict';
  if (window.CyCardFx) return; window.CyCardFx = true;
  var SEL = '[data-cy-card-fx] [data-cy-fx], [data-cy-card-fx] .cy-sys--tiles .hdt-tcwi-inner';
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches, still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var num = function (el, v, d) { var x = parseFloat(getComputedStyle(el).getPropertyValue(v)); return isNaN(x) ? d : x; };
  function tilt(t) {
    var tx = 0, ty = 0, cx = 0, cy = 0, k = 0, raf = 0, on = false;
    /* k = the hover amount, eased like the tilt (owner 2026-10-18 "not smoothly pull up"): the lift and the shadow read it, so the card
       rises and gains depth over ~0.4 s instead of jumping, and settles back the same way */
    var step = function () { cx += (tx - cx) * .16; cy += (ty - cy) * .16; k += ((on ? 1 : 0) - k) * .14;
      t.style.setProperty('--cyfx-rx', cx.toFixed(3) + 'deg'); t.style.setProperty('--cyfx-ry', cy.toFixed(3) + 'deg'); t.style.setProperty('--cyfx-k', k.toFixed(3));
      if (on || Math.abs(cx) > .01 || Math.abs(cy) > .01 || k > .005) raf = requestAnimationFrame(step); else { raf = 0; t.classList.remove('is-tilting'); ['--cyfx-rx', '--cyfx-ry', '--cyfx-k'].forEach(function (p) { t.style.removeProperty(p); }); } };
    var go = function () { if (!raf) raf = requestAnimationFrame(step); };
    t.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'mouse') return; on = true; t.style.setProperty('--cyfx-k', k.toFixed(3)); t.classList.add('is-tilting'); go(); });   /* the start value before the first hover frame paints */
    t.addEventListener('pointermove', function (e) { if (e.pointerType !== 'mouse') return; var r = t.getBoundingClientRect(); var max = num(t, '--cys-card-tilt', 4) * Math.min(1, 320 / Math.max(r.width, 1));
      tx = -((e.clientY - r.top) / r.height - .5) * 2 * max; ty = ((e.clientX - r.left) / r.width - .5) * 2 * max; go(); });
    t.addEventListener('pointerleave', function () { on = false; tx = 0; ty = 0; go(); });
  }
  function touch(cards) {
    var on = function (el) { cards.forEach(function (c) { c.classList.toggle('is-touch', c === el); }); };
    cards.forEach(function (c) { c.addEventListener('pointerdown', function () { on(c); }, { passive: true }); });
    if (!('IntersectionObserver' in window)) return;
    var track = cards[0].closest('[data-cyft-track]') || null, seen = new Map();
    var io = new IntersectionObserver(function (es) { es.forEach(function (x) { seen.set(x.target, x.intersectionRatio); }); var best = null, br = .6; seen.forEach(function (r, el) { if (r > br) { br = r; best = el; } }); if (best) on(best); }, { root: track, threshold: [.6, .8, 1] });
    cards.forEach(function (c) { io.observe(c); });
  }
  function arm(scope) {
    /* phone speed mode (2026-10-24): touch screens skip the in-view card highlight (a class switch while scrolling = a full style pass each time) */
    if (!fine && document.documentElement.classList.contains('cy-lite')) return;
    (scope || document).querySelectorAll('[data-cy-card-fx]').forEach(function (sec) {
      var cards = Array.prototype.slice.call(sec.querySelectorAll('[data-cy-fx], .cy-sys--tiles .hdt-tcwi-inner')).filter(function (c) { return !c.hasAttribute('data-cyfx-on'); });
      if (!cards.length) return; cards.forEach(function (c) { c.setAttribute('data-cyfx-on', ''); });
      if (fine) { if (!still && num(cards[0], '--cys-card-tilt', 4) > 0) cards.forEach(tilt); }
      else if (num(cards[0], '--cys-card-touch', 1) > 0 && cards[0].hasAttribute('data-cy-fx')) touch(cards);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); }); else arm();
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  /* cards that arrive after load (CY Reviews, 2026-10-24) fire cy:cards from their section's wrapper; shopify:section:load would re-boot other scripts */
  document.addEventListener('cy:cards', function (e) { arm(e.target); });
})();

/* ---- PICTURES WITHOUT WAITING (owner 2026-10-24: "without any glitch and loading time on sections"): once the page has loaded, a lazy
   picture starts loading when it is within two screens BELOW the view (the browser's own lazy distance is shorter on phones), so a
   section is ready before it scrolls in. Only what is near: a first version fetched every picture and doubled phone downloads.
   Data saver / 2G keeps plain lazy. ---- */
(function () {
  'use strict';
  if (window.CyWarm || !('IntersectionObserver' in window)) return; window.CyWarm = true;
  if (navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''))) return;
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); e.target.loading = 'eager'; } }); }, { rootMargin: '0px 0px 200% 0px' });
  var watch = function (scope) { (scope || document).querySelectorAll('img[loading="lazy"]').forEach(function (img) { if (!img.complete) io.observe(img); }); };
  var start = function () { watch(); document.addEventListener('cy:cards', function (e) { watch(e.target); }); };
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
})();

/* ---- QUICK FLICKS (owner 2026-10-24: "PDP gallery images are too slow when I use swapping on phone - Sometimes it's take 2 swipe for one
   image ... they swipe fast and stop"): the theme's Embla sliders (hdt-slider: PDP gallery and others) settle back on a short quick flick
   (60 px moved nothing, 100 px 3 times in 4). On touch screens a quick, mostly sideways flick of 30 px or more that left the slide unchanged
   now moves one slide that way. Long drags stay Embla's own. QC: scripts/qc/swipe-check.js ---- */
(function () {
  'use strict';
  if (window.CyFlick || !window.matchMedia || !matchMedia('(hover: none) and (pointer: coarse)').matches) return; window.CyFlick = true;
  var st = null;
  var cur = function (s) { var sl = [].slice.call(s.querySelectorAll('.hdt-slider__slide:not([hidden])')); for (var i = 0; i < sl.length; i++) if (sl[i].classList.contains('is-selected')) return { i: i, n: sl.length }; return { i: -1, n: sl.length }; };
  document.addEventListener('touchstart', function (e) {
    var s = e.touches.length === 1 && e.target.closest ? e.target.closest('hdt-slider') : null;
    if (!s || typeof s.goToIndex !== 'function') { st = null; return; }
    var c = cur(s); st = { s: s, x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now(), i: c.i };
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!st) return; var d = st; st = null; var p = e.changedTouches && e.changedTouches[0]; if (!p) return;
    var dx = p.clientX - d.x, dy = p.clientY - d.y;
    if (d.i < 0 || Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy) * 1.2 || Date.now() - d.t > 400) return;
    setTimeout(function () { var c = cur(d.s); if (c.i !== d.i) return; var to = d.i + (dx < 0 ? 1 : -1); if (to >= 0 && to < c.n) d.s.goToIndex(to); }, 120);
  }, { passive: true });
})();
